var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 96,
    viewBox: "0 0 181 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C3B4F4",
    d: "M145.603 26.998l-12.02 6.94c-2.183 1.26-4.976.512-6.237-1.671l-2.008-3.478c-1.26-2.184-.512-4.976 1.671-6.237.472-.272.872-.62 1.204-1.013l8.82-5.092c4.216-2.434 5.66-7.824 3.227-12.04-2.434-4.214-7.824-5.658-12.04-3.225l-18.07 10.433c-2.184 1.261-4.976.513-6.237-1.67L101.63 5.99c-1.26-2.184-4.053-2.932-6.237-1.67L25.641 44.59c-4.281 2.472-5.748 7.946-3.276 12.227 2.471 4.282 7.946 5.748 12.226 3.277l4.112-2.374c2.183-1.261 4.976-.513 6.237 1.67l2.464 4.27c1.261 2.183.513 4.976-1.67 6.236L29.56 79.233c-4.28 2.471-5.748 7.945-3.276 12.227 2.471 4.28 7.946 5.747 12.227 3.276L70.5 76.267c2.183-1.26 4.976-.512 6.237 1.671l1.826 3.164c1.261 2.183 4.054 2.932 6.237 1.67l69.753-40.27c4.28-2.472 5.747-7.947 3.276-12.227-2.472-4.282-7.946-5.749-12.227-3.277z",
    transform: "translate(-470 -285) translate(430 212) translate(10) translate(30.17 73.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D0F7",
    d: "M176.476 61.84l-27.458 15.853c-3.556 2.053-8.102.834-10.155-2.721-2.052-3.556-.834-8.102 2.721-10.155l27.458-15.852c3.556-2.053 8.102-.835 10.155 2.72 2.053 3.556.835 8.102-2.721 10.155z",
    transform: "translate(-470 -285) translate(430 212) translate(10) translate(30.17 73.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E3F8",
    d: "M38.61 24.752L11.152 40.605C7.596 42.658 3.05 41.44.997 37.884c-2.053-3.556-.834-8.102 2.721-10.155l27.458-15.852c3.556-2.053 8.102-.835 10.155 2.72 2.052 3.556.834 8.102-2.721 10.155z",
    transform: "translate(-470 -285) translate(430 212) translate(10) translate(30.17 73.04)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSingle);
export default __webpack_public_path__ + "static/media/create-single.d77d3ca1.svg";
export { ForwardRef as ReactComponent };